import React from "react"
import Snackbar from '@material-ui/core/Snackbar'
import Slide from "@material-ui/core/Slide"
import SnackbarContent from "@material-ui/core/SnackbarContent"
import * as successAnimationData from "assets/done_animated.json"
import * as errorAnimationData from "assets/exclamation_animated.json"
import Lottie from 'react-lottie'
// import { Theme } from "config"
import { makeStyles } from "@material-ui/core/styles"
import CloseIcon from '@material-ui/icons/Close'
import IconButton from '@material-ui/core/IconButton'

const useStyles = makeStyles(theme => ({
    container: {
        "& .MuiSnackbarContent-root": {
            padding: "0.5rem 0.75rem 0.5rem 2rem",
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary
        }
    },

    content: {
        display: "flex",
        alignItems: "center",
        position: "relative",
        padding: "0 2rem 0 0",

        "& .close-button": {
            position: "absolute",
            top: 0,
            right: 0
        }
    },
    text: {
        width: "20rem"
    }
}))

// const defaultSuccessOptions = {
//     loop: false,
//     autoplay: true, 
//     animationData: animationData.default,
//     rendererSettings: {
//         preserveAspectRatio: 'xMidYMid slice'
//     }
// };

function Content(props){
    const { classes, message, secondaryMessage, onClose, type } = props

    const defaultSuccessOptions = {
        loop: true,
        autoplay: true, 
        animationData: type === "success" ? successAnimationData.default : errorAnimationData.default,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    return (
        <div className={classes.content}>
            {
                type ?
                <Lottie
                    options={defaultSuccessOptions}
                    height={120}
                    width={120}
                    style={{ margin: "0 2rem 0 0" }}
                /> : ""
            }
            
            <div className={classes.text}>
                <h5 className="text-lightweight mb-3">{ message }</h5>
                { secondaryMessage ? <div>{ secondaryMessage }</div> : "" }
            </div>

            <IconButton 
                aria-label="close" 
                className="close-button" 
                size="small"
                onClick={onClose}
            >
                <CloseIcon/>
            </IconButton>
        </div>
    )
}

function TransitionLeft(props) {
    return <Slide {...props} direction="left" />;
}

export default function CommonSnackBar(props){
    const { app } = props, classes = useStyles()

    // let backgroundColor = ""

    // if(app && app.snackbar && app.snackbar.type){
    //     if(app.snackbar.type.toLowerCase() === "success") backgroundColor = Theme.successColor
    //     else if(app.snackbar.type.toLowerCase() === "error") backgroundColor = Theme.errorColor
    // }

    const closeSnackbar = () => {
        props.actionHideSnackbar()
        // console.log("closeSnackbar")
    }

    return(
        <Snackbar
            open={Boolean(app && app.snackbar && app.snackbar.message)}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            autoHideDuration={3000}
            TransitionComponent={TransitionLeft}
            onExited={() => { console.log("Snackbar Exited") }}
            onClose={closeSnackbar}
            className={classes.container}
        >
            <SnackbarContent
                // style={{ backgroundColor }}
                message={(
                    <Content 
                        classes={classes}
                        type={app && app.snackbar && app.snackbar.type && app.snackbar.type.toLowerCase()}
                        onClose={closeSnackbar}
                        secondaryMessage={app && app.snackbar && app.snackbar.secondaryMessage} 
                        message={app && app.snackbar && app.snackbar.message} />
                )}
            />
        </Snackbar>
    )
}